import Vue from "vue";
import VueRouter from "vue-router";
import Login from "../views/auth/Login.vue";
// import Home from "../views/Home.vue";
// import store from '../store'
import firebase from "firebase/app";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: '/dashboard'
  },
  // {
  //   path: "/",
  //   name: "Home",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: Home,
  // },
  {
    path: "/dashboard",
    name: "Dashboard",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "../views/dashboard/Dashboard.vue"),
    meta: {
      requiresAdmin: true
    },
  },
  {
    path: "/add_admin",
    name: "AddAdmin",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "../views/AddAdmin.vue"),
    meta: {
      requiresAdmin: true
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/orgs",
    name: "Organizations",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "../views/organizations/Organizations.vue"),
    meta: {
      requiresAdmin: true
    },
  },
  {
    path: "/orgs/:id",
    name: "OrganizationDetails",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "SpeakerDetail" */ "../views/organizations/OrganizationDetails.vue"
      ),
    meta: {
      requiresAdmin: true
    },
  },
  {
    path: "/users",
    name: "Users",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "dashboard" */ "../views/users/Users.vue"),
    meta: {
      requiresAdmin: true
    },
  },
  {
    path: "/users/:id",
    name: "UserDetails",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "SpeakerDetail" */ "../views/users/UserDetails.vue"
      ),
    meta: {
      requiresAdmin: true
    },
  },
  {
    path: "/transcription/:id",
    name: "TranscriptionDetails",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "SpeakerDetail" */ "../views/transcriptions/TranscriptionDetails.vue"
      ),
    meta: {
      requiresAdmin: true
    },
  },
  {
    path: "/details/:id",
    name: "PostDetails",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "SpeakerDetail" */ "../views/PostDetails.vue"
      ),
    meta: {
      requiresAdmin: true
    },
  },
  {
    path: "/settings",
    name: "Settings",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "settings" */ "../views/Settings.vue"),
    meta: {
      requiresAdmin: true
    },
  }
];

const router = new VueRouter({
  // mode: "history",
  // base: process.env.BASE_URL,
  routes,
});

// // router guards
// router.beforeEach((to, from, next) => {
//   // check to see if route has auth guard
//   if (to.matched.some((rec) => rec.meta.requiresAuth)) {
//     // check auth state of user
//     let user = firebase.auth().currentUser;
//     if (user) {
//       // User is signed in. Proceed to route
//       next();
//     } else {
//       // No user is signed in. Redirect to login
//       next({
//         name: "Login",
//       });
//     }
//   } else {
//     // if route is not guarded by auth, proceed
//     next();
//   }
// });

// router guards
router.beforeEach((to, from, next) => {
  // check to see if route has auth guard
  if (to.matched.some(rec => rec.meta.requiresAdmin)) {
    firebase.auth().currentUser.getIdTokenResult(true) // 1
      .then((idTokenResult) => {
        // 2 Confirm the user is an Admin
        if (idTokenResult.claims.admin) { // 3
          // Show admin UI.
          next()
        } else {
          // Show regular user UI.
          next({
            name: 'Login'
          })
        }
      })
  } else {
    // if route is not guarded by auth, proceed
    next()
  }
  
  // if (to.matched.some(rec => rec.meta.requiresAuth)) {
  //   // check auth state of user
  //   let user = firebase.auth().currentUser
  //   if (user) {
  //     // User is signed in. Proceed to route
  //     next()
  //   } else {
  //     // No user is signed in. Redirect to login
  //     next({
  //       name: 'Login'
  //     })
  //   }
  // } else if (to.matched.some(rec => rec.meta.requiresAdmin)) {
  //   // check custom claims auth of user
  //   firebase.auth().currentUser.getIdTokenResult(true) // 1
  //     .then((idTokenResult) => {
  //       // 2 Confirm the user is an Admin
  //       if (idTokenResult.claims.admin) { // 3
  //         // Show admin UI.
  //         next()
  //       } else {
  //         // Show regular user UI.
  //         next({
  //           name: 'Login'
  //         })
  //       }
  //     })

  // } else {
  //   // if route is not guarded by auth, proceed
  //   next()
  // }
})

export default router;
